import React, { useEffect, useState } from "react";
import { Tooltip, IconButton, Paper, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import StatusChip from "../../../app/features/tender/components/view/Status";
import TableComponent from "@/app/global-components/table";
import StatusTabs from "@/pages/order/components/view/status.tabs";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import QuotationDetailsModal from "@/pages/seller/home/components/responsiveSeller/Wedgits/QuotationDetailsModal";
import ComparisonModal from "@/pages/seller/home/components/responsiveSeller/Wedgits/ComparisonModal";
import useLobby from "@/hooks/use-lobby";
import { LANG } from "@/types";

interface Product {
  id?: string;
  unitName: string;
  quantity: number;
  unitPrice: number;
  attachment?: File | null;
  image?: { url: string };
}

interface TenderQuotation {
  tender: { title: string; id: string; status: string };
  id: string;
  status: string;
  products: Product[];
  deliverDays: number;
  DeadLineDate: string;
  paymentMethod: string;
  DeliveryMethod: string;
  contactMethod: string;
  company: {
    CompanyNr: string;
    nameAr: string;
    website: string;
    address: string;
  };
}

const TrenderQuatationslistCompare: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const { getListtenderQuotations } = useLobby();
  const [listOffers, setListOffers] = useState<TenderQuotation[]>([]);
  const [selectedOffers] = useState<TenderQuotation[]>([]);
  const [selectedQuotation, setSelectedQuotation] =
    useState<TenderQuotation | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [statuses, setStatuses] = useState([
    {
      label: t("status.waiting"),
      name: "Pending",
      total: 0,
      color: "#644980",
      bg: "#ccc",
    },
    {
      label: t("status.accepted"),
      name: "Accepted",
      total: 0,
      color: "#644980",
      bg: "#ccc",
    },
    {
      label: t("status.rejected"),
      name: "Canceled",
      total: 0,
      color: "#644980",
      bg: "#ccc",
    },
  ]);
  useEffect(() => {
    const updatedStatuses = statuses.map((status) => ({
      ...status,
      total: listOffers.filter((order) => order.status === status.name).length,
    }));
    setStatuses(updatedStatuses);
  }, [listOffers]);
  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        const response = await getListtenderQuotations();
        if (response) {
          setListOffers(response.data);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };
    fetchQuotations();
  }, []);

  const handleViewDetails = (quotation: TenderQuotation) => {
    setSelectedQuotation(quotation);
  };

  const handleCloseDetailsModal = () => {
    setSelectedQuotation(null);
  };
  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    setSelectedStatus(newValue);
  };
  const columns = [
    {
      title: t("navigation.Opportunity"),
      field: "tender.title",
      render: (row: TenderQuotation) => row.tender?.title || "N/A",
    },
    {
      title: t("checkout.fields.company"),
      field: "company.nameAr",
      render: (row: TenderQuotation) => row.company?.CompanyNr || "N/A",
    },
    {
      title: t("tender.value"),
      field: "products",
      render: (row: TenderQuotation) =>
        `${row.products
          .reduce(
            (acc, product) => acc + product.unitPrice * product.quantity,
            0
          )
          .toFixed(2)} ${t("currency")}`,
    },
    {
      title: t("orders.fields.status"),
      field: "status",
      render: (row: TenderQuotation) => <StatusChip status={row?.status} />,
    },
    {
      title: t("general.view"),
      field: "id",
      render: (row: TenderQuotation) => (
        <Tooltip title={t("general.view")}>
          <IconButton onClick={() => handleViewDetails(row)}>
            <VisibilityOutlinedIcon style={{ color: "#644980" }} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
  const filteredOrders = listOffers.filter((order) => {
    if (selectedStatus) {
      return order.status === selectedStatus;
    }
    return true;
  });
  const paginatedOffers = filteredOrders;

  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        direction: locale === LANG.AR ? "rtl" : "ltr",
        margin: 0,
      }}
    >
      <Typography variant="h5" style={{ fontWeight: "bold" }}>
        {t("navigation.Quotations")}
      </Typography>
      <Paper
        elevation={0}
        sx={{ mt: 2, p: 2, borderRadius: "10px", maxWidth: "1300px" }}
      >
        <StatusTabs
          statuses={statuses}
          selectedStatus={selectedStatus}
          handleTabChange={handleTabChange}
          orderTotal={listOffers.length}
        />

        <TableComponent
          columns={columns}
          data={paginatedOffers}
          rowKeyField="id"
          pagination
          onRowClick={(row) => handleViewDetails(row)}
        />
        {selectedQuotation && (
          <QuotationDetailsModal
            open={!!selectedQuotation}
            isInfo
            onClose={handleCloseDetailsModal}
            quotation={selectedQuotation}
            offerStatus={selectedQuotation?.tender?.status}
          />
        )}
        {selectedOffers.length > 0 && (
          <ComparisonModal
            onClose={() => console.log("close")}
            open={true}
            offers={selectedOffers}
          />
        )}
      </Paper>
    </div>
  );
};

export default TrenderQuatationslistCompare;
